import React from 'react';

import withStyles from '@mui/styles/withStyles';

import KDatePicker from './KDatePicker';

/*
Call with something like
<DateRangePicker
  startLabel="Start Date"
  endLabel="Last Date"
  startValue={<some Luxon DateTime>}
  endValue={<some Luxon DateTime>}
  onStartValueChange={dt => f(dt)} (where 'dt' is a Luxon DateTime)
  onEndValueChange={dt => f(dt)} (where 'dt' is a Luxon DateTime)
/>
*/

const localStyles = {
  root: {
    textAlign: 'center',
  },
  pickerHolder: {
    display: 'inline-block',
    padding: '0 12px',
  },
};

class DateRangePicker extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, startLabel, endLabel, startValue, endValue, onStartValueChange, onEndValueChange } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.pickerHolder}>
          <KDatePicker label={startLabel} value={startValue} onChange={onStartValueChange} />
        </div>
        <div className={classes.pickerHolder}>
          <KDatePicker label={endLabel} value={endValue} onChange={onEndValueChange} />
        </div>
      </div>
    );
  }
}

export default withStyles(localStyles)(DateRangePicker);
